import { ShipmentTypes } from "src/Library/Types";
import { SHIPMENT_KEY_MAPPINGS } from "../Container/ContainerUtils";
import { SEBLCardData, SEContainerCardData } from "./SE.interfaces";
import isEmpty from 'lodash/isEmpty';
import { isUndefined } from 'util';

export const trackingCardData = (
  cardData: SEContainerCardData | SEBLCardData,
  cardType: ShipmentTypes
) => {
  const keys = SHIPMENT_KEY_MAPPINGS[cardType];
  const res = {
      refreshRequestedAt: cardData[keys.refreshRequestedAt],
      shipmentNumber: cardData[keys.shipmentNumber],
      trackingFetchFailureMessage: cardData[keys.trackingFetchFailureMessage],
      reachedDestinationAt: cardData[keys.reachedDestinationAt],
      routeFrom: cardData[keys.routeFrom],
      cardType,
      ...cardData,
    };
  return res;
};

export const trackingCardDataList = (
  cardDataList: (SEContainerCardData | SEBLCardData)[],
  cardType: ShipmentTypes
) => {
  return cardDataList?.map((cardData) => trackingCardData(cardData, cardType));
};

export type SETrackingCardData = ReturnType<typeof trackingCardData>;

export const uploadSIStepsMap = {
  STAKEHOLDER_AND_SERVICE_DETAILS: 0,
  CONTAINER_AND_CARGO: 1,
  ADDITIONAL_DETAILS: 2,
};

export const seTaskStatus = ['Not Started', 'In Progress', 'Done', 'Cancelled'];

export const siInttraStatusFilterList = [
  { value: 'REQUESTED', label: 'Requested' },
  { value: 'REQUEST_NOT_RAISED', label: 'Request Not Raised' },
];

export const getSIPartyAddress = (address) => {
  if (isEmpty(address)) return '-';
  const { street, city, state, pincode, country } = address;
  const addressString = [street, city, state, pincode, country?.countryName]
    .filter(Boolean)
    .join(', ');

  return addressString;
};

export enum FORM13_CARGO_TYPES {
  GENERAL = 'GENERAL',
  HAZARDOUS = 'HAZARDOUS',
  REEFER = 'REEFER',
  ONION = 'ONION',
  ODC = 'ODC',
}

export const getForm13MandatoryFields = (props) => {
  const {
    portForm13FieldConfigMap,
    mandatoryStuffingLocationAttachments,
    shipmentData,
    stuffingLocation,
    cargoType,
  } = props;
  const polId = shipmentData?.originPolId || shipmentData?.originPortId;
  const getFieldValue = (key, defaultVal) => (isUndefined(key) ? defaultVal : key);
  const isFPodMandatory = getFieldValue(portForm13FieldConfigMap?.[polId]?.fpod, true);
  const isConsigneeNameMandatory = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.consigneeName,
    false
  );
  const isConsigneeAddressMandatory = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.consigneeAddress,
    false
  );
  const isCargoDescriptionMandatory = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.cargoDescription,
    false
  );
  const isTerminalLoginIdMandatory = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.terminalLoginId,
    false
  );
  const isPackageCountMandatory = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.packageCount,
    false
  );
  const isVehicleNoMandatory = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.stuffingLocationVehicle?.[stuffingLocation],
    false
  );
  const mandatoryStuffingAttachmentsBasedOnPOL = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.stuffingLocationAttachments?.[stuffingLocation],
    []
  );
  const mandatoryCarogTypeAttachments = getFieldValue(
    portForm13FieldConfigMap?.[polId]?.carogTypeAttachments?.[cargoType],
    []
  );
  const mandatoryStuffingAttachments = getFieldValue(
    mandatoryStuffingLocationAttachments?.[stuffingLocation],
    []
  );

  return {
    isFPodMandatory,
    isConsigneeNameMandatory,
    isConsigneeAddressMandatory,
    isCargoDescriptionMandatory,
    isTerminalLoginIdMandatory,
    isPackageCountMandatory,
    isVehicleNoMandatory,
    mandatoryStuffingAttachments,
    mandatoryCarogTypeAttachments,
    mandatoryStuffingAttachmentsBasedOnPOL,
  };
};

export const sideBarCollapsedPersistent = (value?: boolean) => {
  if (value === undefined) {
    return JSON.parse(window.localStorage.getItem('SE.sideBarCollapsed') || 'false');
  } else {
    window.localStorage.setItem('SE.sideBarCollapsed', JSON.stringify(value));
    return value;
  }
};
